// extracted by mini-css-extract-plugin
module.exports = {"designManagerBubbleDiv":"_549fb78f","bubble":"_afe55d5","icon":"_a39efa20","printLink":"_f6f330ba","designManagerBubble":"_75ec1034 _afe55d5"};